import { render, staticRenderFns } from "./CategoryImageCarousel.vue?vue&type=template&id=62e5025e&"
import script from "./CategoryImageCarousel.vue?vue&type=script&lang=js&"
export * from "./CategoryImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bensz/src/FrontendStudios/plentyDevTool/HuGVueTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62e5025e')) {
      api.createRecord('62e5025e', component.options)
    } else {
      api.reload('62e5025e', component.options)
    }
    module.hot.accept("./CategoryImageCarousel.vue?vue&type=template&id=62e5025e&", function () {
      api.rerender('62e5025e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/itemList/CategoryImageCarousel.vue"
export default component.exports